import router from '../../router';

/**
 * State
 * @type {Object}
 */
const state = () => ({
	data: null,
	permissions: [],
})

/**
 * Getters
 * @type {Object}
 */
const getters = {
	get: (state, getters, rootState, rootGetters) => state.data,
	can: (state, getters, rootState, rootGetters) => (permission) => state.permissions.includes(permission),
	initials: (state, getters) => getters.get.contact.first_name.charAt(0) + getters.get.contact.last_name.split(' ').pop()?.charAt(0),
}

/**
 * Actions
 * @type {Object}
 */
const actions = {
	login({commit}, {email, password}) {
		return new Promise( (resolve, reject) => {
			this.$xhr.post('/api/auth/login', {email, password}).then( ( {result}) => {
				commit('set', result);
				resolve(result);
			}).catch(reject);
		});
	},

	logout({ commit }) {
		return new Promise( (resolve, reject) => {
			this.$xhr.post('/api/auth/logout').then( ({ result }) => {
				router.push({name: 'login'});
				resolve();
			}).catch(reject)
		})
	},

	authorized({ commit, getters }) {
		return getters.get ?? this.$xhr.post('/api/auth/authorized')
			.then( ({ result }) => {
				commit('set', result);
				return result;
		});
	},

	setAuthorized({ dispatch, commit }) {
		return dispatch('authorized').then(() => commit('setAuthorized'));
	},

    setOtpEnabled({ dispatch, commit }) {
        return commit('setOtpEnabled');
    },

	activate() {
		return new Promise( (resolve, reject) => {
			this.$xhr.post('/api/auth/activate').then( () => {
				resolve();
			}).catch(reject);
		});
	},

	resend() {
		return new Promise( (resolve, reject) => {
			this.$xhr.post('/api/auth/resend').then( () => {
				resolve();
			}).catch(reject);
		});
	},

	restore() {
		return new Promise( (resolve, reject) => {
			this.$xhr.post('/api/auth/restore').then( () => {
				commit('set', result);
				resolve();
			}).catch(reject);
		});
	},

	store({commit}, {data}) {
		return new Promise( (resolve, reject) => {
			this.$xhr.post('/api/clients', data).then( ( {result}) => {
				// commit('set', result);
				resolve();
			}).catch(reject);
		});
	},
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {
	set(state, data) {
		state.data = data;
		state.permissions = data.permission;
	},
	setAuthorized(state) {
		state.data.otp_authorized = true;
	},
    setOtpEnabled(state) {
        state.data.otp_enabled = true;
    }
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
